import React, { useMemo }  from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, CircularProgress, Grid, Button, TextField, Tooltip, Typography } from "@mui/material";
import { AddCircle } from "@mui/icons-material";
import { selectPropertyIds, propertyAdded } from "./propertySlice";
import { tierAdded } from "./tiersSlice";
import { Property } from "./Property";
import { fetchCalculator, fetchAccount, updateAccount, sendEmail } from "../calculators/calculatorsSlice";
import { generatePDF } from "../../utils";

export const Mortgage = () => {
	const dispatch = useDispatch();
	const loadingStatus = useSelector(state => state.mortgage.properties.status);
	const propertyIds = useSelector(selectPropertyIds);
	const view = useSelector(state => state.calculators.view);
	const account = useSelector(state => state.calculators.account);
	const disabled = !!Object.values(account).filter((value) => !value).length;
	const info = [
		{label: "First Name", field: "fname"},
		{label: "Last Name", field: "lname"},
		{label: "Email", field: "email"},
		{label: "Phone Number", field: "phone"}
	];

	const addProperty = () => {
		const id = !!propertyIds.length ? propertyIds[propertyIds.length-1] + 1 : 0;
		dispatch(propertyAdded(""));
		dispatch(tierAdded({id}));
	};

	const send = () => {
		generatePDF(true).then((blob) => {
			const { fname, lname, email, phone } = account;
			dispatch(sendEmail({blob, fname, lname, email, phone}));
		});
	};

	const onChange = (e, field) => {
		const update = {...account, [field]: e.target.value}
		dispatch(updateAccount(update));
	};

	useMemo(() => {
		// -- TODO: uncomment when building
		dispatch(fetchCalculator(view));
		dispatch(fetchAccount());
	}, []);

	return (
		<Box sx={{pt: 3}}>
			{loadingStatus === "loading" &&
				<Box sx={{
					zIndex: "appBar",
					position: "fixed",
					top: 0,
					right: 0,
					bottom: 0,
					left: 0,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					bgcolor: "rgba(255, 255, 255, .5)"
				}}><CircularProgress /></Box>
			}
			<>
				<Grid container spacing={2} sx={{pt: 1, pb: 1.5, "& .MuiTextField-root": {width: "100%"}}}>
					{info.map(({ label, field }) =>
						<Grid key={`account_info_${field}`} item xs={3}>
							<TextField
								{...{label}}
								variant="outlined"
								value={account[field]}
								onChange={(e) => onChange(e, field)}
								InputLabelProps={{shrink: !!account[field]}}
								required
							/>
						</Grid>
					)}
				</Grid>
				{!!propertyIds.length && propertyIds.map((id, index) =>
					<Property key={`property_${id}`} {...{id, index}} />
				)}
				{propertyIds.length < 10 &&
					<Grid item xs={12}>
						<Button
							variant="contained"
							color="success"
							onClick={addProperty}
							sx={{
								p: 3,
								cursor: "pointer",
								display: "flex", alignItems: "center", justifyContent: "center",
								boxShadow: "rgba(46, 125, 50, .2) 0px 0px 10px",
								width: "100%",
								borderRadius: 2
							}}
						>
							<AddCircle sx={{mr: 1}} />
							<Typography variant="button">Add Property</Typography>
						</Button>
					</Grid>
				}
				<Grid item xs={12} sx={{pt: 3, width: "100%", display: "flex", justifyContent: "center"}}>
					<Tooltip title={disabled ? "You must fill in all of your account information at the top." : ""} placement="top" arrow>
						<Box sx={{width: "100%"}}>
							<Button
								{...{disabled}}
								variant="contained"
								onClick={send}
								sx={{
									p: 3,
									cursor: "pointer",
									display: "flex", alignItems: "center", justifyContent: "center",
									boxShadow: "rgba(46, 125, 50, .2) 0px 0px 10px",
									width: "100%",
									borderRadius: 2
								}}
							>
								Finish
							</Button>
						</Box>
					</Tooltip>
				</Grid>
			</>
		</Box>
	);
};